import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { supabase } from '../config/supabase';
import { resetAnalytics } from '../analytics/mixpanel';
import { loadCurrentProfile, setProfileIdentity } from '../stores/profileSession';

export const useAuthSession = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const { data } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'INITIAL_SESSION' || event === 'SIGNED_IN') {
        setProfileIdentity(session?.user.id ?? null, dispatch);
        if (session) void loadCurrentProfile(dispatch);
      } else if (event === 'SIGNED_OUT') {
        setProfileIdentity(null, dispatch);
        resetAnalytics();
      }
    });
    return () => data.subscription.unsubscribe();
  }, [dispatch]);
};

export default useAuthSession;
